// extracted by mini-css-extract-plugin
export default {"container":"nV","promoapplied":"oV","tobeapplied":"pV","hr":"qV","teal":"rV","promoappliedcontainer":"sV","error":"tV","input":"uV","errorInput":"vV","promo_x":"wV","promo_info":"xV","promoxcontainer":"yV"};
    if(module.hot) {
      // 1737143663360
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  